export default __webpack_public_path__ + "static/media/hero-image.859d0b24.jpg";